<template>
    <div>
        <breadcrumbs
            :title="'Dodatne aktivnosti'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Dodatne aktivnosti</h5>
                <br>
                <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click.prevent="create"
                >
                    Nova dodatna aktivnost
                </button>
            </div>

        </div>
        <div class="ibox-content">
            <datatables
                v-if="show_datatable"
                :url="datatables_url"
                :settings="datatables.settings"
                :title="datatables.title"
                @rowClick="rowClick"
            ></datatables>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import Datatables from "../../../../components/datatable/Datatables";
export default {
    name: "DodatneAktivnosti",
    components: { Datatables, Breadcrumbs },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL + 'dodatna-aktivnost',
            datatables: {},
            breadcrumbs: []
        }
    },
    methods: {
        rowClick( row ){
            this.$router.push( { path: '/postavke/dodatne-aktivnosti/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/postavke/dodatne-aktivnosti/create' } )
        },

        setDatatable(){
            let vm = this

            vm.datatables = {
                settings: {
                    table_header: [
                        {
                            'id': 'id',
                            'visible': false
                        },
                        {
                            'id': 'sifra',
                            'title': 'Šifra',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'doatne-aktivnosti',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'naziv',
                            'title': 'Naziv',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'doatne-aktivnosti',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'sati',
                            'title': 'Sati',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'doatne-aktivnosti',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'sati_regulativa',
                            'title': 'Sati regulativa',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'doatne-aktivnosti',
                                'visible' : true
                            }
                        }
                    ],
                    column_visibility_groups:{
                        'dodatne-aktivnosti' : 'Dodatne aktivnosti'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Dodatne aktivnosti'
            }

            vm.show_datatable = true;
        },

        setBreadcrumbs(){

        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>